const firstCharToUpperCase = string => (typeof string === 'string' ?
  string.split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.substring(1))
    .join(' ')
  : string);

export default firstCharToUpperCase;



// WEBPACK FOOTER //
// ./src/utils/firstCharToUpperCase.js